import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";

import FAQImage from "../../images/faq_graphic.jpg";

import "./faq.css";

const FAQ = () => {
  return (
    <section className="faq-section" id="section_4">

      <Container>

          <Col >
            <h2 className="faq-title">
Everything You Need to Know Before You Start
            </h2>
          </Col>
        <Row>


          <div className="w-100"></div>

          <Col lg={5}>
            <img
              src={FAQImage}
              className="img-fluid"
              alt="FAQ"
            />
          </Col>

          <Col lg={6} className="m-auto">

            
<Accordion defaultActiveKey="0">

  <Accordion.Item eventKey="0">
    <Accordion.Header>
      What types of projects and software solutions do you offer?
    </Accordion.Header>

    <Accordion.Body>
      We provide Final Year Projects, Mini Projects, websites, Android and iOS
      applications, custom software, ERP, CRM, eCommerce solutions, business
      websites, and complete web development services. Every project includes
      high-quality source code and professional development standards.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="1">
    <Accordion.Header>
      Do you provide complete source code and project documentation?
    </Accordion.Header>

    <Accordion.Body>
      Yes. Every project includes clean and well-structured source code,
      technical documentation, database files, installation guidance, and user
      manuals. Academic projects also include reports, presentations, and
      project documentation where applicable.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="2">
    <Accordion.Header>
      Can I request a custom website, mobile app, or software project?
    </Accordion.Header>

    <Accordion.Body>
      Absolutely. We develop custom websites, mobile applications, business
      software, ERP systems, CRM solutions, dashboards, and cloud-based
      applications based on your requirements using modern technologies and
      scalable architecture.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="3">
    <Accordion.Header>
      Do you provide support after project delivery?
    </Accordion.Header>

    <Accordion.Body>
      Yes. We offer technical support, maintenance, bug fixes, software
      updates, feature enhancements, and deployment assistance to ensure your
      project continues to perform efficiently after delivery.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="4">
    <Accordion.Header>
      How long does it take to develop a website, mobile app, or software
      project?
    </Accordion.Header>

    <Accordion.Body>
      Development time depends on the project scope, features, and complexity.
      Small projects can be completed within a few days, while larger web
      applications and enterprise software may require several weeks. A detailed
      project timeline is provided before development begins.
    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="5">
    <Accordion.Header>
      Why should I choose your platform for project development?
    </Accordion.Header>

    <Accordion.Body>
      We focus on delivering high-quality websites, mobile apps, software
      solutions, and academic projects with secure coding practices, responsive
      design, modern technologies, affordable pricing, on-time delivery, and
      dedicated customer support for students, startups, and businesses.
    </Accordion.Body>
  </Accordion.Item>

</Accordion>



          </Col>

        </Row>

      </Container>

    </section>
  );
};

export default FAQ;